import React, { useState } from 'react';
import { format } from 'date-fns';
import { el } from 'date-fns/locale';
import { ActionBtn } from './Shared';

const TL_START = 0, TL_END = 24;
const toMin = t => { if(!t) return 0; const [h,m]=t.slice(0,5).split(':').map(Number); return h*60+m; };
const pct = mins => Math.max(0, Math.min(100, ((mins - TL_START*60) / ((TL_END-TL_START)*60)) * 100));

export default function DayDetail({ date, slots, colorFor, busy, onPublish, onEdit, onCancel, onApproveDay, onRejectDay }) { /* @day-level-actions */
  const [editing, setEditing] = useState(null);
  const [ev, setEv] = useState({ start:'', end:'' });
  const tagged = slots.map(s => ({ ...s, status: s.is_published ? 'accepted' : 'pending' }));
  const hourCov = h => tagged.filter(s => toMin(s.start_time) <= h*60 && toMin(s.end_time) > h*60).length;
  const maxCov = Math.max(1, ...Array.from({length:TL_END-TL_START},(_,i)=>hourCov(TL_START+i)));
  const byDoc = {};
  tagged.forEach(s => { const k=s.doctor_id; if(!byDoc[k]) byDoc[k]={ id:k, name:'Δρ. '+(s.doctor_first_name||'')+' '+(s.doctor_last_name||''), init:(s.doctor_first_name?.[0]||'')+(s.doctor_last_name?.[0]||''), color:colorFor(k), slots:[] }; byDoc[k].slots.push(s); });
  const docs = Object.values(byDoc).sort((a,b)=>a.name.localeCompare(b.name,'el'));
  const acceptedN = tagged.filter(s=>s.status==='accepted').length;
  const pendingN = tagged.filter(s=>s.status==='pending').length;
  const saveEdit = (slot) => { if(!ev.start || !ev.end || ev.end <= ev.start) return; onEdit(slot, { startTime: ev.start, endTime: ev.end }); setEditing(null); };
  return (
    <div style={{background:'white',border:'1px solid var(--border)',borderRadius:12,padding:16,marginTop:14}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:14}}>
        <span style={{fontSize:15,fontWeight:700,color:'var(--navy)'}}>{format(date,'EEEE, d MMMM yyyy',{locale:el})}</span>
        <span style={{display:'flex',alignItems:'center',gap:10}}>
          <span style={{fontSize:12,color:'var(--muted)'}}><span style={{color:'#0D6A45',fontWeight:700}}>{acceptedN} εγκεκριμένα</span> · <span style={{color:'#9A5B12',fontWeight:700}}>{pendingN} εκκρεμή</span></span>
          {pendingN>0 && onApproveDay && <ActionBtn variant="approve" disabled={busy} onClick={onApproveDay}>✓ Έγκριση ημέρας ({pendingN})</ActionBtn>}
          {pendingN>0 && onRejectDay && <ActionBtn variant="reject" disabled={busy} onClick={onRejectDay}>Απόρριψη ημέρας</ActionBtn>}
        </span>
      </div>
      <div style={{marginBottom:16}}>
        <div style={{fontSize:12,color:'var(--muted)',marginBottom:6}}>Κάλυψη ανά ώρα</div>
        <div style={{display:'flex',alignItems:'flex-end',gap:1,height:52}}>
          {Array.from({length:TL_END-TL_START},(_,i)=>{const h=TL_START+i;const c=hourCov(h);return (
            <div key={h} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',gap:2}}>
              <div style={{width:'100%',height:`${(6+38*(c/maxCov)).toFixed(0)}px`,background:c?'var(--crimson)':'var(--border)',borderRadius:2,opacity:c?Number((0.35+0.65*(c/maxCov)).toFixed(2)):1}} title={`${h}:00 — ${c} ιατροί`}/>
              <span style={{fontSize:8,color:'var(--muted)'}}>{h}</span>
            </div>
          );})}
        </div>
      </div>
      {docs.length===0 ? <div style={{textAlign:'center',padding:20,color:'var(--muted)',fontSize:13}}>Καμία διαθεσιμότητα για αυτή την ημέρα.</div> :
      docs.map(doc=>(
        <div key={doc.id} style={{border:'1px solid var(--border)',borderRadius:10,marginBottom:10,overflow:'hidden'}}>
          <div style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:'var(--bg)'}}>
            <div style={{width:30,height:30,borderRadius:'50%',background:doc.color,color:'white',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700}}>{doc.init}</div>
            <div style={{flex:1,fontSize:13,fontWeight:700,color:'var(--navy)'}}>{doc.name}</div>
          </div>
          {doc.slots.map(slot=>{
            const accepted = slot.status==='accepted';
            return (
            <div key={slot.id} style={{padding:'10px 14px',borderTop:'1px solid var(--border)'}}>
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                <span style={{fontSize:11,fontWeight:700,padding:'2px 8px',borderRadius:20,background:accepted?'#E4F5EC':'#FDF0DF',color:accepted?'#0D6A45':'#9A5B12',whiteSpace:'nowrap'}}>{accepted?'Εγκεκριμένο':'Εκκρεμές'}</span>
                <span style={{fontSize:13,fontWeight:700,color:'var(--navy)',whiteSpace:'nowrap'}}>{slot.start_time?.slice(0,5)} – {slot.end_time?.slice(0,5)}</span>
              </div>
              <div style={{position:'relative',height:14,background:'var(--bg)',borderRadius:4,marginBottom:8}}>
                <div style={{position:'absolute',top:0,bottom:0,left:`${pct(toMin(slot.start_time))}%`,width:`${(pct(toMin(slot.end_time))-pct(toMin(slot.start_time))).toFixed(2)}%`,minWidth:4,background:accepted?doc.color:'transparent',border:`1.5px solid ${doc.color}`,borderRadius:4}} title={`${slot.start_time?.slice(0,5)}–${slot.end_time?.slice(0,5)}`}/>
              </div>
              {editing===slot.id ? (
                <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap'}}>
                  <input type="time" value={ev.start} onChange={e=>setEv(v=>({...v,start:e.target.value}))} style={{padding:6,borderRadius:6,border:'1px solid var(--border)'}}/>
                  <span>–</span>
                  <input type="time" value={ev.end} onChange={e=>setEv(v=>({...v,end:e.target.value}))} style={{padding:6,borderRadius:6,border:'1px solid var(--border)'}}/>
                  <ActionBtn variant="approve" disabled={busy} onClick={()=>saveEdit(slot)}>Αποθήκευση</ActionBtn>
                  <ActionBtn disabled={busy} onClick={()=>setEditing(null)}>Άκυρο</ActionBtn>
                </div>
              ) : (
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  {!accepted && <ActionBtn variant="approve" disabled={busy} onClick={()=>onPublish(slot)}>✓ Έγκριση</ActionBtn>}
                  <ActionBtn disabled={busy} onClick={()=>{setEditing(slot.id);setEv({start:slot.start_time?.slice(0,5),end:slot.end_time?.slice(0,5)});}}>Αλλαγή ώρας</ActionBtn>
                  <ActionBtn variant="reject" disabled={busy} onClick={()=>onCancel(slot)}>Ακύρωση</ActionBtn>
                </div>
              )}
            </div>
          );})}
        </div>
      ))}
    </div>
  );
}
